import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FolderTwoToneSvg from "@ant-design/icons-svg/es/asn/FolderTwoTone";
import AntdIcon from "../components/AntdIcon";
var FolderTwoTone = function FolderTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FolderTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FolderTwoTone.displayName = 'FolderTwoTone';
}
export default /*#__PURE__*/React.forwardRef(FolderTwoTone);